import { render, staticRenderFns } from "./sidebar.pug?vue&type=template&id=87a0cc52&scoped=true&lang=pug&"
import script from "./sidebar.ts?vue&type=script&lang=ts&"
export * from "./sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./sidebar.scss?vue&type=style&index=0&id=87a0cc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a0cc52",
  null
  
)

export default component.exports